import React, { Component } from 'react';

// Externals
import { Doughnut } from 'react-chartjs-2';
import classNames from 'classnames';
import PropTypes from 'prop-types';

// Material helpers
import { withStyles } from '@material-ui/core';

// Shared components
import {
  Portlet,
  PortletHeader,
  PortletLabel,
  PortletContent
} from 'components';


// Chart configuration
import { options } from './chart';

// Component styles
import styles from './styles';

class ImpressionChart extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { classes, className, data, ...rest } = this.props;

    const rootClassName = classNames(classes.root, className);

    const pieData = {
      labels: data.datasets.map( d => d.label ),
      datasets: [{
        backgroundColor: data.datasets.map( d => d.backgroundColor),
        data: data.datasets.map( d => d.data.reduce(( acc, cur ) => acc + cur, 0 ))
      }]
    }

    return (
      <Portlet
        {...rest}
        className={rootClassName}
      >
        <PortletHeader noDivider>
          <PortletLabel title="Impression Analysis" />
        </PortletHeader>
        <PortletContent>
          <div className={classes.chartWrapper}>
            <Doughnut
              data={pieData}
              options={options}
            />
          </div>
        </PortletContent>
      </Portlet>
    );
  }
}

ImpressionChart.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(ImpressionChart);
